import Constants from 'src/utilities/constants'
import {objectById} from './utilities/utils'
import Permissions from 'src/utilities/permissions'

const ALL = {
  READ: [
    Permissions.CAMUNDA,
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.DASHBOARD,
    Permissions.FILES,
    Permissions.HISTORY,
    Permissions.IDA,
    Permissions.INSPECTIONS,
    Permissions.INSPECTOR_APP,
    Permissions.INSPECTOR_ROUTING,
    Permissions.IN_TOUCH,
    Permissions.INVOICES,
    Permissions.JOBS,
    Permissions.JOB_TEMPLATES,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.MY_TASKS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.REPORTS,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.TAGS,
    Permissions.TASKS,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.USERS,
  ],
  CREATE: [
    Permissions.INVOICES,
    Permissions.JOBS,
    Permissions.PROJECTS,
    Permissions.SUPPLY_PRO
  ],
  DELETE: [
    Permissions.DELETE.PROJECTS
  ],
  EDIT: [
    Permissions.ASSIGN_TASKS,
    Permissions.CAMUNDA,
    Permissions.CANCEL_JOBS,
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.COMPLETED_TASKS,
    Permissions.COMPLETE_TASKS.ASSIGNED_TO_USER,
    Permissions.COMPLETE_TASKS.NOT_ASSIGNED_TO_USER,
    Permissions.FILES,
    Permissions.INSPECTIONS,
    Permissions.INSPECTOR_APP,
    Permissions.JOBS,
    Permissions.JOB_TEMPLATES,
    Permissions.JOB_TERMINATE_PROCESS_INSTANCE,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.LINKED_TASKS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.SYSTEM_TASK_VALUES,
    Permissions.TAGS,
    Permissions.TASKS,
    Permissions.TASK_DUE_DATE,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.TASK_TERMINATE_JOBS_TASKS,
    Permissions.USERS
  ]
}

const ADMIN_USERS = {
  READ: [
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.FILES,
    Permissions.HISTORY,
    Permissions.IDA,
    Permissions.INSPECTIONS,
    Permissions.IN_TOUCH,
    Permissions.INVOICES,
    Permissions.JOBS,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.MY_TASKS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.REPORTS,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.TAGS,
    Permissions.TASKS,
    Permissions.TASK_NAMES,
    Permissions.USERS
  ],
  DENY_READ: [
    Permissions.CAMUNDA,
    Permissions.DASHBOARD,
    Permissions.IDA,
    Permissions.INSPECTOR_APP,
    Permissions.INSPECTOR_ROUTING,
    Permissions.TASK_TEMPLATES,
    Permissions.JOB_TEMPLATES
  ],
  CREATE: [
    Permissions.JOBS,
    Permissions.INVOICES,
    Permissions.PROJECTS,
    Permissions.SUPPLY_PRO
  ],
  DENY_CREATE: [],
  EDIT: [
    Permissions.ASSIGN_TASKS,
    Permissions.CAMUNDA,
    Permissions.CANCEL_JOBS,
    Permissions.CITIES,
    Permissions.COMPANIES,
    Permissions.COMPLETE_TASKS.ASSIGNED_TO_USER,
    Permissions.COMPLETE_TASKS.NOT_ASSIGNED_TO_USER,
    Permissions.COMPLETED_TASKS,
    Permissions.COMMUNITIES,
    Permissions.FILES,
    Permissions.INSPECTIONS,
    Permissions.JOBS,
    Permissions.JOB_TERMINATE_PROCESS_INSTANCE,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.SYSTEM_TASK_VALUES,
    Permissions.TAGS,
    Permissions.TASKS,
    Permissions.TASK_DUE_DATE,
    Permissions.TASK_NAMES,
    Permissions.USERS
  ],
  DENY_EDIT: [
    Permissions.CAMUNDA,
    Permissions.INSPECTOR_APP,
    Permissions.JOB_TEMPLATES,
    Permissions.LINKED_TASKS,
    Permissions.TASK_TEMPLATES,
    Permissions.TASK_TERMINATE_JOBS_TASKS
  ],
  DENY_DELETE: [
    Permissions.DELETE.PROJECTS
  ]
}

const POWER_USERS = {
  READ: [
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.FILES,
    Permissions.HISTORY,
    Permissions.IDA,
    Permissions.INSPECTIONS,
    Permissions.INVOICES,
    Permissions.IN_TOUCH,
    Permissions.JOBS,
    Permissions.MY_TASKS,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.REPORTS,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.TASKS,
    Permissions.USERS
  ],
  DENY_READ: [
    Permissions.CAMUNDA,
    Permissions.DASHBOARD,
    Permissions.IDA,
    Permissions.INSPECTOR_APP,
    Permissions.INSPECTOR_ROUTING,
    Permissions.JOB_TEMPLATES,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES
  ],
  CREATE: [
    Permissions.INVOICES,
    Permissions.PROJECTS,
    Permissions.JOBS,
    Permissions.SUPPLY_PRO
  ],
  DENY_CREATE: [],
  EDIT: [
    Permissions.ASSIGN_TASKS,
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.COMPLETE_TASKS.ASSIGNED_TO_USER,
    Permissions.COMPLETE_TASKS.NOT_ASSIGNED_TO_USER,
    Permissions.FILES,
    Permissions.INSPECTIONS,
    Permissions.JOBS,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.SYSTEM_TASK_VALUES,
    Permissions.TASKS,
    Permissions.TASK_DUE_DATE,
    Permissions.USERS
  ],
  DENY_EDIT: [
    Permissions.CAMUNDA,
    Permissions.CANCEL_JOBS,
    Permissions.COMPLETED_TASKS,
    Permissions.INSPECTOR_APP,
    Permissions.JOB_TEMPLATES,
    Permissions.JOB_TERMINATE_PROCESS_INSTANCE,
    Permissions.LINKED_TASKS,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.TASK_TERMINATE_JOBS_TASKS
  ],
  DENY_DELETE: [
    Permissions.DELETE.PROJECTS
  ]
}

const ADVANCED_USERS = {
  READ: [
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.FILES,
    Permissions.IDA,
    Permissions.INSPECTIONS,
    Permissions.IN_TOUCH,
    Permissions.JOBS,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.MY_TASKS,
    Permissions.PROJECTS,
    Permissions.STREETS,
    Permissions.TASKS
  ],
  DENY_READ: [
    Permissions.CAMUNDA,
    Permissions.DASHBOARD,
    Permissions.IDA,
    Permissions.INSPECTOR_APP,
    Permissions.INSPECTOR_ROUTING,
    Permissions.INVOICES,
    Permissions.JOB_TEMPLATES,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.QB.ITEM_CODES,
    Permissions.REPORTS,
    Permissions.SUPPLY_PRO,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.USERS
  ],
  CREATE: [
    Permissions.FILES
  ],
  DENY_CREATE: [
    Permissions.INVOICES
  ],
  EDIT: [
    Permissions.ASSIGN_TASKS,
    Permissions.COMPLETE_TASKS.ASSIGNED_TO_USER,
    Permissions.COMPLETE_TASKS.NOT_ASSIGNED_TO_USER,
    Permissions.FILES,
    Permissions.TASK_DUE_DATE,
    Permissions.TASKS
  ],
  DENY_EDIT: [
    Permissions.CAMUNDA,
    Permissions.CANCEL_JOBS,
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.COMPLETED_TASKS,
    Permissions.INSPECTIONS,
    Permissions.INSPECTOR_APP,
    Permissions.JOBS,
    Permissions.JOB_TEMPLATES,
    Permissions.JOB_TERMINATE_PROCESS_INSTANCE,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.LINKED_TASKS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.SYSTEM_TASK_VALUES,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.TASK_TERMINATE_JOBS_TASKS,
    Permissions.USERS
  ],
  DENY_DELETE: [
    Permissions.DELETE.PROJECTS
  ]
}

const STANDARD_USERS = {
  READ: [
    Permissions.FILES,
    Permissions.JOBS,
    Permissions.MY_TASKS,
    Permissions.PROJECTS,
    Permissions.TASKS
  ],
  DENY_READ: [
    Permissions.CAMUNDA,
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.DASHBOARD,
    Permissions.IDA,
    Permissions.INSPECTIONS,
    Permissions.INSPECTOR_APP,
    Permissions.INSPECTOR_ROUTING,
    Permissions.IN_TOUCH,
    Permissions.INVOICES,
    Permissions.JOB_TEMPLATES,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.QB.ITEM_CODES,
    Permissions.REPORTS,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.USERS
  ],
  CREATE: [],
  DENY_CREATE: [
    Permissions.INVOICES,
    Permissions.JOBS,
    Permissions.PROJECTS
  ],
  EDIT: [
    Permissions.COMPLETE_TASKS.ASSIGNED_TO_USER,
  ],
  DENY_EDIT: [
    Permissions.ASSIGN_TASKS,
    Permissions.CAMUNDA,
    Permissions.CANCEL_JOBS,
    Permissions.CITIES,
    Permissions.COMMUNITIES,
    Permissions.COMPANIES,
    Permissions.COMPLETED_TASKS,
    Permissions.COMPLETE_TASKS.NOT_ASSIGNED_TO_USER,
    Permissions.INSPECTIONS,
    Permissions.INSPECTOR_APP,
    Permissions.FILES,
    Permissions.JOB_TEMPLATES,
    Permissions.JOB_TERMINATE_PROCESS_INSTANCE,
    Permissions.JOBS,
    Permissions.LEGAL_SUBDIVISIONS,
    Permissions.LINKED_TASKS,
    Permissions.PLAN_NAMES,
    Permissions.PRICE_RULES,
    Permissions.PROJECTS,
    Permissions.QB.ITEM_CODES,
    Permissions.STREETS,
    Permissions.SUPPLY_PRO,
    Permissions.SYSTEM_TASK_VALUES,
    Permissions.TASKS,
    Permissions.TASK_DUE_DATE,
    Permissions.TASK_NAMES,
    Permissions.TASK_TEMPLATES,
    Permissions.TASK_TERMINATE_JOBS_TASKS,
    Permissions.USERS
  ],
  DENY_DELETE: [
    Permissions.DELETE.PROJECTS
  ]
}

export function defineAbilitiesForUser(ability, userGroups) {
  const rules = []
  const groups = JSON.parse(JSON.stringify(userGroups))

  if (groups.includes(Constants.GROUPS.SUPER_USERS)) {
    rules.push({ actions: 'create', subject: ALL.CREATE })
    rules.push({ actions: 'read', subject: ALL.READ })
    rules.push({ actions: 'edit', subject: ALL.EDIT })
    rules.push({ actions: 'delete', subject: ALL.DELETE })
  } else if (groups.includes(Constants.GROUPS.ADMIN_USERS)) {
    rules.push({ actions: 'create', subject: ADMIN_USERS.CREATE })
    rules.push({ actions: 'create', subject: ADMIN_USERS.DENY_CREATE, inverted: true })
    rules.push({ actions: 'read', subject: ADMIN_USERS.READ })
    rules.push({ actions: 'read', subject: ADMIN_USERS.DENY_READ, inverted: true })
    rules.push({ actions: 'edit', subject: ADMIN_USERS.EDIT })
    rules.push({ actions: 'edit', subject: ADMIN_USERS.DENY_EDIT, inverted: true })
    rules.push({ actions: 'delete', subject: ADMIN_USERS.DENY_DELETE, inverted: true })
  } else if (groups.includes(Constants.GROUPS.POWER_USERS)) {
    rules.push({ actions: 'create', subject: POWER_USERS.CREATE })
    rules.push({ actions: 'create', subject: POWER_USERS.DENY_CREATE, inverted: true })
    rules.push({ actions: 'read', subject: POWER_USERS.READ })
    rules.push({ actions: 'read', subject: POWER_USERS.DENY_READ, inverted: true })
    rules.push({ actions: 'edit', subject: POWER_USERS.EDIT })
    rules.push({ actions: 'edit', subject: POWER_USERS.DENY_EDIT, inverted: true })
    rules.push({ actions: 'delete', subject: POWER_USERS.DENY_DELETE, inverted: true })
  } else if (groups.includes(Constants.GROUPS.ADVANCED_USERS)) {
    rules.push({ actions: 'create', subject: ADVANCED_USERS.CREATE })
    rules.push({ actions: 'create', subject: ADVANCED_USERS.DENY_CREATE, inverted: true })
    rules.push({ actions: 'read', subject: ADVANCED_USERS.READ})
    rules.push({ actions: 'read', subject: ADVANCED_USERS.DENY_READ, inverted: true })
    rules.push({ actions: 'edit', subject: ADVANCED_USERS.EDIT })
    rules.push({ actions: 'edit', subject: ADVANCED_USERS.DENY_EDIT, inverted: true })
    rules.push({ actions: 'delete', subject: ADVANCED_USERS.DENY_DELETE, inverted: true })
  } else if (groups.includes(Constants.GROUPS.STANDARD_USERS)) {
    rules.push({ actions: 'create', subject: STANDARD_USERS.CREATE })
    rules.push({ actions: 'create', subject: STANDARD_USERS.DENY_CREATE, inverted: true })
    rules.push({ actions: 'read', subject: STANDARD_USERS.READ })
    rules.push({ actions: 'read', subject: STANDARD_USERS.DENY_READ, inverted: true })
    rules.push({ actions: 'edit', subject: STANDARD_USERS.EDIT })
    rules.push({ actions: 'edit', subject: STANDARD_USERS.DENY_EDIT, inverted: true })
    rules.push({ actions: 'delete', subject: STANDARD_USERS.DENY_DELETE, inverted: true })
  } else {
    // users not in a group - DENY ALL
    rules.push({ actions: 'read', subject: ALL.READ, inverted: true })
    rules.push({ actions: 'edit', subject: ALL.EDIT, inverted: true })
    rules.push({ actions: 'delete', subject: ALL.DELETE, inverted: true })
  }

  if (groups.includes(Constants.GROUPS.GPS_USERS)) {
    rules.push({ actions: 'read', subject: [Permissions.IN_TOUCH] })
  }

  if (groups.includes(Constants.GROUPS.INSPECTION_ROUTERS)) {
    rules.push({ actions: 'read', subject: [Permissions.INSPECTIONS] })
    rules.push({ actions: 'read', subject: [Permissions.INSPECTOR_ROUTING] })
  }

  if (groups.includes(Constants.GROUPS.IDA_USERS)) {
    rules.push({ actions: 'read', subject: [Permissions.IDA] })
  }

  ability.update(rules)
}
